import React, { Component } from "react";
import userAvatars from "./userAvatars.js";

export default class DashboardStats extends Component {
  render() {
    const { companyhighscore, company, highscore } = this.props;

    const rank = companyhighscore?.rank || "-";
    const companyAmount = companyhighscore?.companyAmount || "-";
    const doneActivities = company?.amountOfDoneActivities || 0;

    // Format activities with dot separator for thousands
    const formattedActivities = doneActivities.toLocaleString("da-DK");

    // Get top 3 users from highscore
    const topUsers = highscore?.highscore?.slice(0, 3) || [];

    console.log(highscore?.highscore);

    return (
      <div className="stats-container">
        <div className="stats-top-row">
          <div className="stats-card">
            <div className="stats-header">
              <span className="stats-label">Placering</span>
            </div>
            <div className="stats-value">
              <span className="stats-rank">{rank}</span>
              <span className="stats-separator"> af </span>
              <span className="stats-total">{companyAmount}</span>
            </div>
          </div>

          <div className="stats-card">
            <div className="stats-header">
              <span className="stats-label">Klimahandlinger</span>
            </div>
            <div className="stats-value">
              <span className="stats-activities">{formattedActivities}</span>
            </div>
          </div>
        </div>

        <div className="stats-podium-card">
          <div className="podium-header">
            <span className="podium-title">Top Spillere</span>
          </div>
          <div className="podium-container">
            {topUsers.length >= 3 && (
              <>
                {/* Second place - left */}
                <div className="podium-place podium-second">
                  <div className="podium-avatar podium-avatar-silver">
                    {topUsers[1]?.avatarId &&
                    userAvatars[topUsers[1].avatarId] ? (
                      <img
                        src={userAvatars[topUsers[1].avatarId]}
                        alt={topUsers[1].userName}
                        className="podium-avatar-img"
                      />
                    ) : (
                      <div className="podium-avatar-placeholder">2</div>
                    )}
                  </div>
                  <div className="podium-medal podium-medal-silver">2</div>
                  <div className="podium-name">{topUsers[1]?.userName}</div>
                  <div className="podium-points">
                    {topUsers[1]?.totalPoints?.toLocaleString("da-DK")}p
                  </div>
                  <div className="podium-stand podium-stand-silver"></div>
                </div>

                {/* First place - center */}
                <div className="podium-place podium-first">
                  <div className="podium-crown">&#128081;</div>
                  <div className="podium-avatar podium-avatar-gold">
                    {topUsers[0]?.avatarId &&
                    userAvatars[topUsers[0].avatarId] ? (
                      <img
                        src={userAvatars[topUsers[0].avatarId]}
                        alt={topUsers[0].userName}
                        className="podium-avatar-img"
                      />
                    ) : (
                      <div className="podium-avatar-placeholder">1</div>
                    )}
                  </div>
                  <div className="podium-medal podium-medal-gold">1</div>
                  <div className="podium-name">{topUsers[0]?.userName}</div>
                  <div className="podium-points podium-points-gold">
                    {topUsers[0]?.totalPoints?.toLocaleString("da-DK")}p
                  </div>
                  <div className="podium-stand podium-stand-gold"></div>
                </div>

                {/* Third place - right */}
                <div className="podium-place podium-third">
                  <div className="podium-avatar podium-avatar-bronze">
                    {topUsers[2]?.avatarId &&
                    userAvatars[topUsers[2].avatarId] ? (
                      <img
                        src={userAvatars[topUsers[2].avatarId]}
                        alt={topUsers[2].userName}
                        className="podium-avatar-img"
                      />
                    ) : (
                      <div className="podium-avatar-placeholder">3</div>
                    )}
                  </div>
                  <div className="podium-medal podium-medal-bronze">3</div>
                  <div className="podium-name">{topUsers[2]?.userName}</div>
                  <div className="podium-points">
                    {topUsers[2]?.totalPoints?.toLocaleString("da-DK")}p
                  </div>
                  <div className="podium-stand podium-stand-bronze"></div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}
